import {HelpLinks, helpLinksFoundercrate, helpLinksRecordskeeper} from './helpLinks'

type BrandingConfig = {
  brandName: string
  brandDescription: string
  lightModeLogo: string
  darkModeLogo: string
  favicon: string
  loader: string
  freeTrialDays: string
  authPageSliderContent: {image: string; heading: string; subHeading: string}[]
  authLandingPage: {
    header: string
    subHeader: string
    features: {image: string; heading: string; subHeading: string}[]
    benefits: {image: string; heading: string; subHeading: string}[]
    reviews: {reviewDesc: string; profilePic: string; name: string; position: string}[]
    faqs: {question: string; answer: string}[]
  }
  supportEmail: string
  productRoadmapLink: string
  suggestFeatureLink: string
  defaultLocale: string
  defaultTimezone: string
  defaultDateFormat: string
  invoiceDefaultDateFormate: string,
  defaultTimeFormat: string
  defaultCountry: string
  companyDetails: {
    displayName: string
    india?: {
      name: string
      address: string
    }
    us?: {
      name: string
      address: string
    }
  }
  supportUrl: string
  termsUrl: string
  privacyUrl: string
  refundUrl: string
  helpDeskUrl: string
  customerSupportUrl: string
  changeLogUrl: string
  unsubscribeUrl: string
  socialLinks: {
    linkedin: string
    twitter: string
    youtube: string
    instagram: string
    facebook: string
    blog: string
    website: string
    reddit: string
    discord: string
    telegram: string
    slideShare: string
  }
  helpLinks: HelpLinks
}

const brandingConfigs: Record<string, BrandingConfig> = {
  FC: {
    brandName: 'Foundercrate',
    brandDescription: 'Best tool for Investor CRM &amp; Fundraising process',
    lightModeLogo: process.env.REACT_APP_LIGHT_MODE_LOGO || '/media/auth/fc-logo-lightmode.svg',
    darkModeLogo: process.env.REACT_APP_DARK_MODE_LOGO || '/media/auth/fc-logo-darkmode.svg',
    favicon: process.env.REACT_APP_FAVICON || '/media/logos/favicon.ico',
    loader: process.env.REACT_APP_LOADER || '/media/auth/fc-logo-lightmode.svg',
    freeTrialDays:'3',
    authPageSliderContent: [
      {
        image: '/media/auth/slide1.png',
        heading: 'Streamline your process',
        subHeading:
          'Simplify investor management, maximize your reach, and accelerate your success.',
      },
      {
        image: '/media/auth/slide2.png',
        heading: 'Massive Investors Database',
        subHeading:
          'Access 200,000+ investor profiles with contact info, preferences, and history.',
      },
      {
        image: '/media/auth/slide3.png',
        heading: 'Secured Data Rooms',
        subHeading:
          'Share and manage crucial documents securely. Control access rights and track document interactions.',
      },
    ],
    authLandingPage: {
      header: 'Reduce Fundraising Cycle & Increase Funding Rate by 50%',
      subHeader: `FounderCrate is a full-stack fundraising CRM & Investor Relation Management (IRM) suite for startup founders to streamline the fundraising processes collaboratively. It helps you outreach & simplify investor management, maximize your reach, and accelerate your success.`,
      features: [
        {
          image: '/media/auth/icons/ic-database.svg',
          heading: 'Massive Investor Database',
          subHeading:
            'Access 200,000+ investor profiles with contact info, preferences, and history.',
        },
        {
          image: '/media/auth/icons/ic-crm.svg',
          heading: 'Investor CRM (IRM)',
          subHeading: 'Centralize communications and track investor engagement tasks.',
        },
        {
          image: '/media/auth/icons/ic-mail.svg',
          heading: 'Personalized Email & Investor Update Tool',
          subHeading: 'Send personalized bulk emails, use templates, and track engagement.',
        },
        {
          image: '/media/auth/icons/ic-data.svg',
          heading: 'Secure Data Room & Digital Signing',
          subHeading: 'Securely share and manage documents. Control access and track interactions.',
        },
        {
          image: '/media/auth/icons/ic-collab.svg',
          heading: 'Collaborative Fundraising & Analytics',
          subHeading:
            'Track team efforts and investor engagement. Monitor fundraising with our dashboard.',
        },
        {
          image: '/media/auth/icons/ic-stakeholder.svg',
          heading: 'Shareholders Meeting Management',
          subHeading:
            'Manage stakeholders, board meetings. Schedule meetings and get AI-generated MoM.',
        },
        {
          image: '/media/auth/icons/ic-captable.svg',
          heading: 'Cap Table & ESOP Management',
          subHeading:
            'Define and manage Employee Stock Options. Employee logins for independent management.',
        },
      ],
      benefits: [
        {
          image: '/media/auth/icons/ic-cycle.svg',
          heading: 'Reduce Fundraising Cycle',
          subHeading:
            'Reduce the fundraising cycle by up to 50% and Focus more on growing your business, not just fundraising',
        },
        {
          image: '/media/auth/icons/ic-grow.svg',
          heading: 'Increase Success Rate',
          subHeading:
            'Structured and disciplined processes improve your chances of successful fundraising',
        },
        {
          image: '/media/auth/icons/ic-global.svg',
          heading: 'Global Reach',
          subHeading:
            'Engage investors from around the world and Utilize data-driven insights for better outreach',
        },
      ],
      reviews: [
        {
          reviewDesc: 'FounderCrate cut our fundraising time in half. The tools are indispensable!',
          profilePic: '/media/testimonials/emily.png',
          name: 'Emily Davis',
          position: 'CFO, LearnTech',
        },
        {
          reviewDesc: `We secured funding faster thanks to FounderCrate's investor database and CRM.`,
          profilePic: '/media/testimonials/pradeep.png',
          name: 'Pradeep Kumar',
          position: 'Founder, Robomart',
        },
        {
          reviewDesc:
            'The personalized emails and investor profiles helped us connect with the right investors.',
          profilePic: '/media/testimonials/david.png',
          name: 'David Wilson',
          position: 'CEO, FinGrow',
        },
        {
          reviewDesc: `With FounderCrate, we were able to identify and reach out to potential investors.`,
          profilePic: '/media/testimonials/lee.png',
          name: 'James Lee',
          position: 'COO, GreenEnergy Solutions',
        },
      ],
      faqs: [
        {
          question: 'Is Foundercrate Right for Me?',
          answer: `Foundercrate is ideal for startups at any stage of their fundraising journey. Whether you're just starting to seek investors or looking to optimize ongoing efforts, Foundercrate provides the tools to streamline and enhance your process. Perfect for teams who want to efficiently manage investor relationships and improve their chances of securing funding.`,
        },
        {
          question: 'How Secure is My Data?',
          answer:
            'Your data security is our top priority. Foundercrate employs state-of-the-art security measures, including encryption and secure data storage, to ensure your information is protected. Our platform is trusted by startups worldwide, giving you peace of mind as you manage sensitive investor and business information.',
        },
        {
          question: 'What Happens After the Free Trial?',
          answer:
            'After the 3-day free trial, you can choose from our flexible pricing plans starting at $49/month. These plans offer continued access to our full suite of features, allowing you to maintain efficient fundraising and investor management efforts. You can upgrade, downgrade, or cancel your plan at any time to suit your business needs.',
        },
      ],
    },
    supportEmail: 'support@foundercrate.com',
    productRoadmapLink: 'https://foundercrate.featurebase.app/roadmap',
    suggestFeatureLink: 'https://foundercrate.featurebase.app/?b=667bafb5b6795e509069e776',
    defaultLocale: 'en-US',
    defaultTimezone: 'EST',
    defaultDateFormat: 'DD MMM, YYYY',
    invoiceDefaultDateFormate: "dd MMM, yyyy",
    defaultTimeFormat: 'h:mm:ss a',
    defaultCountry: 'USA',
    companyDetails: {
      displayName: 'Foundercrate',
      india: {
        name: 'Ashto Innovations Private Limited',
        address: '5E/35 B.P., NIT Faridabad, Faridabad, Haryana, Pin 121001, India',
      },
    },
    supportUrl: 'https://help.foundercrate.com/en/',
    termsUrl: 'https://www.foundercrate.com/terms-of-services',
    privacyUrl: 'https://www.foundercrate.com/privacy-policy',
    refundUrl: 'https://www.foundercrate.com/refund-policy/',
    changeLogUrl: 'https://foundercrate.featurebase.app/changelog',
    helpDeskUrl: 'https://help.foundercrate.com/?utm_source=app&utm_medium=support-menu',
    customerSupportUrl: 'https://help.foundercrate.com/?utm_source=app&utm_medium=support-menu',
    unsubscribeUrl: 'https://app.foundercrate.com/settings/user-settings',
    socialLinks: {
      linkedin: 'https://www.linkedin.com/company/foundercrate/',
      twitter: 'https://twitter.com/foundercrate',
      youtube: 'https://www.youtube.com/@Foundercrate/',
      instagram: 'https://www.instagram.com/foundercrate/',
      facebook: 'https://www.facebook.com/Foundercrate/',
      blog: 'https://www.foundercrate.com/blogs',
      website: 'https://www.foundercrate.com',
      reddit: '',
      discord: '',
      telegram: '',
      slideShare: '',
    },
    helpLinks: helpLinksFoundercrate,
  },
  RK: {
    brandName: 'RecordsKeeper.AI',
    brandDescription:
      'RecordsKeeper.AI - AI-Powered Records Management Automation: Turning Data Chaos into Actionable Strategic Intelligence',
    lightModeLogo:
      process.env.REACT_APP_LIGHT_MODE_LOGO ||
      '/media/logos/rk/recordskeeper-ai-logo-for-light-mode.svg',
    darkModeLogo:
      process.env.REACT_APP_DARK_MODE_LOGO ||
      '/media/logos/rk/recordskeeper-ai-logo-for-dark-mode.svg',
    favicon: process.env.REACT_APP_FAVICON || '/media/logos/RecordsKeeper-AI-favicon-54x54.svg',
    loader: process.env.REACT_APP_LOADER || '/media/logos/rk/rk-logo-lightmode.svg',
    freeTrialDays:'3',
    authPageSliderContent: [
      {
        image: '/media/auth/RKSlide1.png',
        heading: 'Automated & Intelligent Record Keeping with AI & Blockchain',
        subHeading: `Automatically Categorize & Classify Your Records with AI automation, & Protect with Blockchain-based Security.`,
      },
      {
        image: '/media/auth/RKSlide2.png',
        heading: `Powerful Document Search with RecordsKeeper.AI Chat`,
        subHeading:
          'Revolutionize document access with AI-driven search and intelligent retrieval in 250+ languages',
      },
      {
        image: '/media/auth/RKSlide3.png',
        heading: 'Streamline Meeting, Captable With AI-Powered Management Tools',
        subHeading:
          'Make Shareholders Management, Corporate Meetings & Captable Management more efficient and compliant with AI-powered scheduling, documentation, and automated follow-up.',
      },
    ],
    authLandingPage: {
      header: 'Transform Your Record Management with AI & Blockchain',
      subHeader:
        'Streamline your record management processes with AI-powered automation and blockchain security. RecordsKeeper.AI helps professionals automate up to 85% of manual documentation tasks while ensuring tamper-proof compliance.',
      features: [
        {
          image: '/media/auth/icons/ic-record-management.svg',
          heading: 'AI-Powered Record Management',
          subHeading:
            'Transform your documents into organized, searchable assets with intelligent automation.',
        },
        {
          image: '/media/auth/icons/ic-blockchain.svg',
          heading: 'Blockchain Security & Compliance',
          subHeading:
            'Ensure tamper-proof records and automatic compliance tracking for GDPR, HIPAA, & SOX.',
        },
        {
          image: '/media/auth/icons/ic-smart-search.svg',
          heading: 'Smart Document Search',
          subHeading:
            'Find any document instantly using natural language queries and chat-based retrieval.',
        },
        {
          image: '/media/auth/icons/ic-data.svg',
          heading: 'Secure Data Room & Digital Signing',
          subHeading:
            'Share documents securely and manage digital signatures with complete control.',
        },
        {
          image: '/media/auth/icons/ic-analytics-monitoring.svg',
          heading: 'Compliance Analytics & Monitoring',
          subHeading:
            'Track activities, generate audit reports, and maintain compliance effortlessly.',
        },
        {
          image: '/media/auth/icons/ic-interconnect.svg',
          heading: 'Multi-Channel Record Management',
          subHeading:
            'Integrate with email, WhatsApp, and existing systems for seamless record handling.',
        },
      ],
      benefits: [
        {
          image: '/media/auth/icons/ic-reduce-work.svg',
          heading: 'Reduce Manual Work by 85%',
          subHeading: 'Automate document handling and focus on strategic tasks, not paperwork.',
        },
        {
          image: '/media/auth/icons/ic-file-secure.svg',
          heading: 'Enhanced Security & Compliance',
          subHeading:
            'Maintain perfect compliance with blockchain-backed security and audit trails.',
        },
        {
          image: '/media/auth/icons/ic-multi-channel.svg',
          heading: 'Instant Document Access',
          subHeading: 'Find any record in seconds with AI-powered natural language search.',
        },
      ],
      reviews: [
        {
          reviewDesc: ``,
          profilePic: '/media/testimonials/emily.png',
          name: '',
          position: 'Managing Partner',
        },
        {
          reviewDesc: `After 15 years in accounting, I've never seen a more efficient system. The compliance automation handles GDPR seamlessly.`,
          profilePic: '/media/testimonials/pradeep.png',
          name: 'Pradeep Kumar',
          position: 'Founder, Robomart',
        },
        {
          reviewDesc:
            'Managing corporate compliance for multiple subsidiaries used to be a nightmare. Data rooms and meeting management have made my job easier.',
          profilePic: '/media/testimonials/david.png',
          name: 'David Wilson',
          position: 'CEO, FinGrow',
        },
      ],
      faqs: [
        {
          question: 'How quickly can we get started with RecordsKeeper.AI?',
          answer:
            'You can start using RecordsKeeper.AI immediately after sign up. Our AI begins organizing your documents as soon as you upload them.',
        },
        {
          question: 'Is there a limit on the number of documents I can store?',
          answer: `Our flexible pricing plans scale with your needs. Whether you're a small firm managing thousands of documents or a large enterprise with millions of records, we have plans designed to accommodate your storage requirements while maintaining optimal performance.`,
        },
        {
          question: 'Can I try RecordsKeeper.AI before committing?',
          answer:
            `Yes! We offer a 3-day trial that gives you full access to all features. Experience how RecordsKeeper.AI can transform your record management firsthand.`,
        },
      ],
    },
    supportEmail: 'support@help.recordskeeper.ai',
    productRoadmapLink: 'https://recordskeeper.featurebase.app/roadmap',
    suggestFeatureLink: 'https://recordskeeper.featurebase.app/?b=674ec3bc4bb5c2d72900b650',
    defaultLocale: 'en-US',
    defaultTimezone: 'EST',
    defaultDateFormat: 'DD MMM, YYYY',
    invoiceDefaultDateFormate: "dd MMM, yyyy",
    defaultTimeFormat: 'h:mm:ss a',
    defaultCountry: 'USA',
    companyDetails: {
      displayName: 'RecordsKeeper.AI',
      india: {
        name: 'RecordsKeeper Technologies Private Limited',
        address: 'Springhouse Coworking, Grand Mall, LG-01, Gurugram 122001',
      },
      us: {
        name: 'RecordsKeeper.AI',
        address: `2261 Market Street STE, 86483 San Francisco, CA 94114`,
      },
    },
    supportUrl: 'https://help.recordskeeper.ai/en/',
    termsUrl: 'https://www.recordskeeper.ai/terms-of-services/',
    privacyUrl: 'https://www.recordskeeper.ai/privacy-policy/',
    refundUrl: 'https://www.recordskeeper.ai/refund-policy/',
    changeLogUrl: '',
    helpDeskUrl: 'https://help.recordskeeper.ai/en',
    customerSupportUrl: 'mailto:support@help.recordskeeper.ai',
    unsubscribeUrl: 'https://app.recordskeeper.ai/settings/user-settings',
    socialLinks: {
      linkedin: 'https://www.linkedin.com/company/recordskeeper/',
      twitter: 'https://twitter.com/records_keeper',
      youtube: 'https://www.youtube.com/@RecordsKeeperAI',
      instagram: 'https://www.instagram.com/recordskeeper.ai',
      facebook: 'https://www.facebook.com/RecordsKeeperAI',
      blog: 'https://www.recordskeeper.ai/blog/',
      website: 'https://www.recordskeeper.ai/',
      reddit: 'https://www.reddit.com/r/RecordsKeeper_AI/',
      discord: 'https://discord.gg/UUqdGaCn',
      telegram: 'https://t.me/recordskeeper',
      slideShare: 'https://www.slideshare.net/RecordsKeeper ',
    },
    helpLinks: helpLinksRecordskeeper,
  },
}

// Get the current brand's config based on the environment variable
const BRAND = process.env.REACT_APP_BRAND || 'FC'
// const BRAND = 'RK'
const brandingConfig: BrandingConfig = brandingConfigs[BRAND]

export default brandingConfig
